import React , {useState, useMemo, useEffect} from 'react'
import VisDiv from "../../whitaijiFrontendLibrary/components/VisDiv";
import BlueButton from "../BlueButton";
import TextField from "../../whitaijiFrontendLibrary/components/TextField";
import { generateMongoDBId } from '../../whitaijiFrontendLibrary/lib/utils'; 

const LongText = ({data={}}) => {

    const {doc, setDoc} = data
    const question = useMemo(() => ({ questionId: data?._id }), [data]);
    const [userResponse, setUserResponse] = useState()
    const [userText, setUserText] = useState("")

    useEffect(()=>{
      const initialUserResponse = doc?.userResponses?.find((item)=>item?.questionId === question?.questionId)
      //process.env.NODE_ENV === "development" && console.log("initialUserResponse", initialUserResponse)
      if (initialUserResponse) {
        setUserText(initialUserResponse?.answers?.[0]?.answerText || "");
        setUserResponse(initialUserResponse)
      }

    }, [doc, question])

    const testFunction = () => {
      process.env.NODE_ENV === "development" && console.log("userResponse", userResponse)
    }
    const questionId = question?.questionId
    const updateDoc = (doc={}, newAnswerDoc={}) => {
        const existingAnswers = !doc?.userResponses ? [] : doc?.userResponses
        const newDoc = {...doc, userResponses:[...existingAnswers?.filter((x)=>x?.questionId !== newAnswerDoc?.questionId), newAnswerDoc]}
        //process.env.NODE_ENV === "development" && console.log("existingAnswers", existingAnswers, newDoc)
        return newDoc
    }
    const answerFn = () => {
        const newAnswerDoc = {questionId, answers:[{answerText: userText, answerId: generateMongoDBId()}]}
        process.env.NODE_ENV === "development" && console.log("userResponse", newAnswerDoc)
        setUserResponse(newAnswerDoc)
        setDoc(updateDoc(doc, newAnswerDoc)) 
    }

  return (
    <div>
      <BlueButton fn={testFunction}/>
      <VisDiv>
        <textarea 
          className="text-area-input"
          onChange={(e) => setUserText(e.target.value)}
          value={userText}
          onBlur={answerFn}/>
      </VisDiv>
    </div>
  )
}

export default LongText
